import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import { WorkerPool } from '@recruitee/common';
import { HttpApiService } from '@recruitee/http';
import type { ReferralOfferAssignment } from '@recruitee/referrals-types';

@Injectable({ providedIn: 'root' })
export class OfferAssignmentHttpClient {
  constructor(
    private httpApi: HttpApiService,
    private workerPool: WorkerPool,
  ) {}

  public loadOfferAssignment(offerId: string): Observable<ReferralOfferAssignment> {
    return this.httpApi
      .get(`referral/offers/${offerId}/offer_assignment`)
      .pipe(
        switchMap(data => this.workerPool.fillInReferences(data.offerAssignment, data.references)),
      );
  }

  public offerRewardToggle({
    offerId,
    enabled,
  }: {
    offerId: string;
    enabled: boolean;
  }): Observable<Partial<ReferralOfferAssignment>> {
    return this.httpApi
      .patch(`/referral/offers/${offerId}/toggle`, null, {
        offer_assignment: { enabled },
      })
      .pipe(map(data => data.offerAssignment));
  }

  public offerRewardAssign({
    offerId,
    referralRewardId,
  }: {
    offerId: string;
    referralRewardId: number | null;
  }): Observable<Partial<ReferralOfferAssignment>> {
    return this.httpApi
      .patch(`/referral/offers/${offerId}/assign_reward`, null, {
        offer_assignment: {
          referralRewardId,
        },
      })
      .pipe(map(data => data.offerAssignment));
  }

  public loadOffersEnabled(params?: { q: string }): Observable<ReferralOfferAssignment[]> {
    return this.httpApi
      .get(`/referral/offers/enabled`, params)
      .pipe(
        switchMap(data => this.workerPool.fillInReferences(data.offerAssignments, data.references)),
      );
  }

  public assignTemplate({
    offerId,
    templateId,
  }: {
    offerId: number;
    templateId: number | null;
  }): Observable<ReferralOfferAssignment> {
    return this.httpApi
      .patch(`/referral/offers/${offerId}/assign_template`, null, {
        offer_assignment: {
          referral_template_id: templateId,
        },
      })
      .pipe(
        switchMap(data => this.workerPool.fillInReferences(data.offerAssignment, data.references)),
      );
  }
}
